import React, { Component, Fragment } from 'react'
import { Grid, Content } from '../../components/Layout'
import { pxToRem, color } from '../../utils'
import { connect } from 'react-redux'
import styled from 'styled-components'
import Sidebar from '../../components/Sidebar'
import Header from '../../components/Header'
import { Select, DownloadButton } from '../../components/Form'
import Box from '../../components/Box'
import { controlledProductReportActions } from '../../actions'
import iconPdf from '../../assets/icons/iconPdf.svg'
import iconExcel from '../../assets/icons/iconExcel.svg'
import ResponsiblesContent from '../../components/ResponsiblesContent'
import ContentHeader from '../../components/ContentHeader'

const ContentBody = styled(Box)`
  width: 100%;
  margin: auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  padding: 20px 0 20px 20px;

  @media only screen and (max-width: 550px) {
    flex-direction: column;
    padding: 20px;
  }
`

const WrapperSelect = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;

  @media only screen and (max-width: 550px) {
    width: 100%;
  }
`

const SelectFilter = styled(Select)`
  margin: auto;
  margin-bottom: 15px;
  float: right;
  width: 100%;
  font-size: ${pxToRem(13)};
`

const WrapperButton = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  @media only screen and (max-width: 550px) {
    width: 100%;
  }
`

const ActionButton = styled(DownloadButton)`
  margin: 10px;

  img {
    height: 14px;
    width: 14px;
    margin-right: 2px;
  }
`

class ControlledProductReport extends Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    this.props.fetchAreas()
    this.props.fetchControlledComponent()
    this.props.fetchSupervisories()
  }

  changeAreas = (areas) => {
    this.props.fetchChangeAreas(areas)
  }

  changeControlledComponents = (controlledComponents) => {
    this.props.fetchChangeControlledComponents(controlledComponents)
  }

  changeSupervisories = (supervisories) => {
    this.props.fetchChangeSupervisories(supervisories)
  }

  downloadPdf = () => {
    const {
      selectedAreas,
      selectedControlledComponents,
      selectedSupervisories,
      fetchDownloadPdf
    } = this.props

    fetchDownloadPdf(selectedAreas, selectedControlledComponents, selectedSupervisories)
  }

  downloadXls = () => {
    const {
      selectedAreas,
      selectedControlledComponents,
      selectedSupervisories,
      fetchDownloadXls
    } = this.props

    fetchDownloadXls(selectedAreas, selectedControlledComponents, selectedSupervisories)
  }

  render() {
    const {
      areaList = [],
      controlledComponentList = [],
      supervisoriesList = [],
      menuItems = [],
      router,
      loadingDownloadPdf,
      loadingDownloadXls,
      selectedAreas,
      selectedControlledComponents,
      selectedSupervisories
    } = this.props

    const {
      changeAreas,
      changeControlledComponents,
      changeSupervisories,
      downloadPdf,
      downloadXls,
    } = this

    return (
      <Fragment>
        <Grid>
          <Header router={router} />
          <Sidebar menuItems={menuItems} router={router} />
          <Content>
            <ContentHeader
              title="Produtos Controlados"
              subtitle="Relatório"
            >
            </ContentHeader>
            <ContentBody>
              <WrapperSelect>
                <SelectFilter
                  isMulti
                  placeholder="Todas as áreas"
                  value={selectedAreas}
                  onChange={value => {
                    changeAreas(value)
                  }}
                  options={[...areaList]}
                />
                <SelectFilter
                  isMulti
                  placeholder="Todos os componentes controlados"
                  value={selectedControlledComponents}
                  onChange={value => {
                    changeControlledComponents(value)
                  }}
                  options={[...controlledComponentList]}
                />
                <SelectFilter
                  isMulti
                  placeholder="Todos os orgãos reguladores"
                  value={selectedSupervisories}
                  onChange={value => {
                    changeSupervisories(value)
                  }}
                  options={[...supervisoriesList]}
                />
              </WrapperSelect>
              <WrapperButton>
                <ActionButton
                  loading={loadingDownloadPdf}
                  onClick={
                    downloadPdf
                  }
                >
                  <img src={iconExcel} />PDF
                </ActionButton>
                <ActionButton
                  loading={loadingDownloadXls}
                  onClick={
                    downloadXls
                  }
                >
                  <img src={iconPdf} />Excel
                </ActionButton>
              </WrapperButton>
            </ContentBody>
            <ResponsiblesContent />
          </Content>
        </Grid>
      </Fragment>
    )
  }
}

const mapStateToProps = state => {
  const {
    areaList,
    productList,
    fetching,
    areaId,
    productId,
    productName,
    controlledComponentId,
    controlledComponentName,
    controlledComponentList
  } = state.controlledProductReport
  return {
    areaList: state.controlledProductReport.areaList,
    controlledComponentList: state.controlledProductReport.controlledComponentList,
    supervisoriesList: state.controlledProductReport.supervisoriesList,
    selectedAreas: state.controlledProductReport.selectedAreas,
    selectedControlledComponents: state.controlledProductReport.selectedControlledComponents,
    selectedSupervisories: state.controlledProductReport.selectedSupervisories,
    loadingDownloadPdf: state.controlledProductReport.fetching.downloadPdf,
    loadingDownloadXls: state.controlledProductReport.fetching.downloadXls,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchAreas: text => {
      dispatch(controlledProductReportActions.fetchAreas(text))
    },
    fetchControlledComponent: () => {
      dispatch(controlledProductReportActions.fetchControlledComponent())
    },
    fetchSupervisories: () => {
      dispatch(controlledProductReportActions.fetchSupervisories())
    },
    fetchChangeAreas: (areas) => {
      dispatch(controlledProductReportActions.fetchChangeAreas(areas))
    },
    fetchChangeControlledComponents: (controlledComponents) => {
      dispatch(controlledProductReportActions.fetchChangeControlledComponents(controlledComponents))
    },
    fetchChangeSupervisories: (supervisories) => {
      dispatch(controlledProductReportActions.fetchChangeSupervisories(supervisories))
    },
    fetchDownloadPdf: (areas, controlledComponents, supervisories) => {
      dispatch(controlledProductReportActions.fetchDownloadPdf(areas, controlledComponents, supervisories))
    },
    fetchDownloadXls: (areas, controlledComponents, supervisories) => {
      dispatch(controlledProductReportActions.fetchDownloadXls(areas, controlledComponents, supervisories))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ControlledProductReport)



// WEBPACK FOOTER //
// ./src/containers/ControlledProducts/ControlledProductReport.js